import Link from 'next/link';
import {
  CardListWrapper,
  CardLayout,
} from '@/components/Rank/SoloRank/SoloRank.styled';
import { LeagueT } from '@/types/league';

interface CardListContainerProp {
  data: Array<LeagueT>;
}

const { RIOT_CDN_URL } = process.env;

export default function CardListContainer({ data }: CardListContainerProp) {
  const handleClickLink = (ranking: number) => {
    if (analytics) {
      const idx = `랭킹 ${ranking}`;
      analytics.track('product_clicked', {
        product_name: idx,
        product_id: idx,
      });
    }
  };

  return (
    <CardListWrapper>
      {data
        .slice(0, 5)
        .sort((a, b) => b.league_points - a.league_points)
        .map(
          (
            {
              id,
              wins,
              losses,
              league_points,
              tier,
              summoner: { profile_id, name, summoner_level },
            }: LeagueT,
            i: number
          ) => {
            const profileImg = `${RIOT_CDN_URL}/12.11.1/img/profileicon/${profile_id}.png`;
            return (
              <div key={id} onClick={() => handleClickLink(i)}>
                <Link href={`/records/${name}`} passHref>
                  <CardLayout profileImg={profileImg}>
                    <div className="summoner-info-wrapper">
                      <div className="rank">{RANK_UNIT[i]}</div>
                      <div className="summoner">{name}</div>
                      <div className="level">{summoner_level}LV</div>
                    </div>
                    <div className="summoner-rank-wrapper">
                      <div className="summoner-rank">
                        <div className="rank">
                          <div className="info-wrapper">
                            <span className="label">티어</span>
                            <span className="value">{tier}</span>
                          </div>
                          <div className="info-wrapper">
                            <span className="label">승</span>
                            <span className="value">{wins}</span>
                          </div>
                          <div className="info-wrapper">
                            <span className="label">점수</span>
                            <span className="value">{league_points}LP</span>
                          </div>
                          <div className="info-wrapper">
                            <span className="label">패</span>
                            <span className="value">{losses}</span>
                          </div>
                          <div className="info-wrapper">
                            <span className="label">승률</span>
                            <span className="value">
                              {Math.floor((wins / (losses + wins)) * 100)}%
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="summoner-rank-wrapper-overlay" />
                    </div>
                  </CardLayout>
                </Link>
              </div>
            );
          }
        )}
    </CardListWrapper>
  );
}

const RANK_UNIT = ['1st', '2nd', '3rd', '4th', '5th'];
